import React from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/components/SessionExpiryModal.css';

const SessionExpiryModal = () => {
  const { showExpiryWarning, timeUntilExpiry, refreshToken, logout, dismissWarning } = useAuth();

  if (!showExpiryWarning) return null;

  const formatTime = (seconds) => {
    if (seconds === null) return '--:--';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handleContinue = async () => {
    const success = await refreshToken();
    if (!success) {
      alert('No se pudo renovar la sesión. Por favor, inicia sesión nuevamente.');
    }
  };

  const handleLogout = () => {
    dismissWarning();
    logout();
    window.location.href = '/login';
  };

  return (
    <div className="session-expiry-overlay">
      <div className="session-expiry-modal">
        <div className="session-expiry-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <h2>Tu sesión está por expirar</h2>
        <p className="session-expiry-message">
          Por seguridad, tu sesión expirará en:
        </p>
        <div className="session-expiry-countdown">
          {formatTime(timeUntilExpiry)}
        </div>
        <p className="session-expiry-question">
          ¿Deseas continuar trabajando?
        </p>
        <div className="session-expiry-buttons">
          <button className="btn-continue" onClick={handleContinue}>
            Sí, continuar
          </button>
          <button className="btn-logout" onClick={handleLogout}>
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiryModal;
